<template>
  <div class="create_wrapper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("addNew") }}</h4>
      </div>

      <!-- ==== Start Form ==== -->

      <form @submit.prevent="validateCreateForm">
        <div class="container">
          <div class="row justify-content-between">
            <div class="col-12 row justify-content-center">
              <div class="col-lg-4 col-md-6">
                <div class="upload_input_wrapper">
                  <uplode-image
                    :data_src="data.flag"
                    @inputChanged="uplodeImg_1"
                    placeHolder="علم الدولة "
                  ></uplode-image>
                </div>
                <!-- End:: Flag Input -->
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isArabic"
                  v-model.trim="data.alt_image_ar"
                />
                <label for="name_input" class="form-label"
                  >النص البديل للصورة (عربي)</label
                >
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isEnglish"
                  v-model.trim="data.alt_image_en"
                />
                <label for="name_input" class="form-label"
                  >النص البديل للصورة (إنجليزي)</label
                >
              </div>
            </div>
            <!-- Start:: Ar title -->
            <div class="col-lg-5 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isArabic"
                  v-model.trim="data.ar.title"
                />
                <label for="name_input" class="form-label">
                  اسم الدولة (عربي)
                </label>
              </div>
            </div>
            <!-- End:: Ar title -->

            <!-- Start:: En title -->
            <div class="col-lg-5 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isEnglish"
                  v-model.trim="data.en.title"
                />
                <label for="name_input" class="form-label">
                  أسم الدولة (انجليزي)
                </label>
              </div>
            </div>
            <!-- End:: En title -->

            <!-- Start:: En code -->
            <div class="col-lg-2 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="number"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.phoneCode"
                />
                <label for="name_input" class="form-label">
                  كود الدولة
                </label>
              </div>
            </div>
            <!-- End:: En code -->
          </div>
          <div class="buttons_wrapper">
            <button class="base-btn">
              {{ $t("forms.submit") }}
              <span class="btn_loader" v-if="btnIsLoading"></span>
            </button>
          </div>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Update",

  props: ["id"],
  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.phone_codes.title"),
          disabled: false,
          href: "/phone-codes",
        },
        {
          text: this.$t("breadcrumb.phone_codes.edit"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,

      // ========== Data
      data: {
        alt_image_en: null,
        alt_image_ar: null,
        ar: {
          title: null,
        },
        en: {
          title: null,
        },
        flag: null,
        phoneCode: null,
      },
    };
  },

  methods: {
    // Uplode Image
    uplodeImg_1(obj) {
      this.data.flag = obj;
    },

    // Empty Form Data
    emptyFormData() {
      this.data.flag = null;
      this.data.ar.title = null;
      this.data.en.title = null;
      this.data.phoneCode = null;
    },

    // Validate Data
    validateCreateForm() {
      this.btnIsLoading = true;
      console.log(this.data);
      if (!this.data.ar.title) {
        this.$iziToast.error({
          timeout: 2000,
          message: "ادخل اسم الدولة بالعربي",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.en.title) {
        this.$iziToast.error({
          timeout: 2000,
          message: "ادخل اسم الدولة بالانجليزي",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.flag) {
        this.$iziToast.error({
          timeout: 2000,
          message: "ادخل علم الدولة ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.phoneCode) {
        this.$iziToast.error({
          timeout: 2000,
          message: "ادخل كود الدولة ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (this.data.phoneCode <= 0) {
        this.$iziToast.error({
          timeout: 2000,
          message: " كود الدولة  غير صحيح ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.submitData();
        return;
      }
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();

      if (this.data.alt_image_ar) {
        submit_data.append(`ar[alt_image]`, this.data.alt_image_ar);
      }
      if (this.data.alt_image_en) {
        submit_data.append(`en[alt_image]`, this.data.alt_image_en);
      }
      submit_data.append("ar[title]", this.data.ar.title);
      submit_data.append("en[title]", this.data.en.title);
      if (this.data.flag.img_file) {
        submit_data.append("flag", this.data.flag.img_file);
      }
      submit_data.append("phone_code", this.data.phoneCode);
      submit_data.append("_method", "PUT");
      this.axios({
        method: "POST",
        url: `phone_code/${this.id}`,
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("editSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/phone-codes" });
          this.btnIsLoading = false;
          this.emptyFormData();
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
    // Get Data
    getData() {
      this.axios({
        method: "GET",
        url: `phone_code/${this.id}`,
      })
        .then((res) => {
          return (this.data = {
            ar: {
              title: res.data.data.title_ar,
            },
            en: {
              title: res.data.data.title_en,
            },
            alt_image_en: res.data.data.alt_image_en,
            alt_image_ar: res.data.data.alt_image_ar,
            flag: res.data.data.flag,
            phoneCode: res.data.data.phone_code,
          });
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.$router.push({ path: "/phone-codes" });
        });
    },
  },
  mounted() {
    // this.getData()
  },
};
</script>
<style lang="scss" scoped>
.repeater_wrapper {
  border: 1px solid #29398c;
  border-radius: 15px;
  padding-block: 20px;

  h3,
  h5 {
    color: #29398c;
  }

  &.disabled {
    cursor: not-allowed;

    h3 {
      color: gray;
      font-size: 25px;
    }

    h4 {
      font-size: 21px;
      color: gray;
    }

    & > * {
      pointer-events: none;
    }
  }
}
</style>
